import React from 'react'
import styles from './CommunitieSwitcher.module.scss'
import miscUtils from 'utils/miscUtils';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import ContentLoader from 'react-content-loader';
import { GroupService } from 'api/services/groups';
import { useAtom } from 'jotai';
import { showCommunitySwitcherAtom } from 'showMessageMenuAtom';
import {
    DragDropContext,
    Droppable,
    Draggable,
} from 'react-beautiful-dnd';
import { toast } from 'react-toastify';
import ThreeDotsIcon from './ThreeDotsIcon';
import PlusIcon from './PlusIcon';
import { AuthorizeService } from 'api/services/authorize/AuthorizeService';


const CommunitieSwitcher = ({ userId, selectedGroup }: { selectedGroup: any, userId: any }) => {
    const [userGroups, setUserGroups] = React.useState<any>(null);
    const [error, setError] = React.useState<any>(null);
    const baseURL = miscUtils.getBaseDomain();
    const utm_content = process.env.REACT_APP_FREE_PLAN_UTM;

    function goToGroup(grp: any) {
        if (grp.id === selectedGroup.id) {
            return
        }
        const isCustomDomain = grp && grp.custom_domain && grp.custom_domain_ssl_active_at !== null;
        if (isCustomDomain) {
            return grp.url
            // window.location.assign(grp.url)
        } else {
            return miscUtils.getRedirectBaseUrl(grp)
            // window.location.assign(miscUtils.getRedirectBaseUrl(grp))
        }
    }

    const [showCommunitySwitcher,] = useAtom(showCommunitySwitcherAtom) as any;

    const topBarEl = document.getElementById('GroupAppHeader');
    React.useEffect(() => {
        fetchUserGroups();
    }, [
        userId,
        selectedGroup && selectedGroup.user_membership && selectedGroup.user_membership.id
    ])


    const fetchUserGroups = () => {
        if (window.location.pathname.split("/")[1] === 'settings') return
        if (userId) {
            GroupService.getInstance()
                .getUserGroupsForCommunitySidebar(userId)
                .then((response: any) => {
                    setUserGroups(response);
                }).catch((error: any) => {
                    console.error(error)
                    setError(error)
                })
        }
    }

    const loadMoreUserGroups = () => {
        if (userGroups) {
            GroupService.getInstance()
                .LoadmoreUserGroupsForCommunitySidebar(`${userGroups.next_page_url}&side-bar=true`)
                .then((response: any) => {
                    setUserGroups((prev: any) => ({
                        ...response,
                        data: [...prev.data, ...response.data],
                    }));
                }).catch((error: any) => console.error(error))
        }
    }

    const handleDragEnd = (result: any) => {
        const { source, destination } = result;
        if (!destination) return;

        const reordered = Array.from(userGroups.data);
        const [movedItem] = reordered.splice(source.index, 1);
        reordered.splice(destination.index, 0, movedItem);

        // Build final position payload (starting from 1 instead of 0)
        const positionPayload: Record<string, number> = {};
        reordered.forEach((group: any, index: number) => {
            positionPayload[group.id] = index + 1; // index starts from 1
        });

        if (!userId) return

        GroupService.getInstance()
            .arrageUserGroupsForCommunitySidebar(userId, { position: positionPayload })
            .then((response: any) => {
                toast(`${response.message}`, {
                    type: 'success',
                    autoClose: 3000,
                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
            }).catch((error: any) => console.error(error))

        setUserGroups((prev: any) => ({
            ...prev,
            data: reordered
        }));
    };

    const theme = selectedGroup && selectedGroup.custom_branding && selectedGroup.custom_branding.primaryColor
    const isCustomgroupTheme = theme && theme !== '#ffffff'
    const isVerified = selectedGroup && selectedGroup.user_membership && selectedGroup.user_membership.user && selectedGroup.user_membership.user.verified
    const isCustomDomain = selectedGroup && selectedGroup.custom_domain && selectedGroup.custom_domain_status === "active";

    const isGroupDataRequired =
        window.location.hostname !== 'my.group.app' &&
        window.location.hostname !== 'group.localhost' &&
        window.location.hostname !== 'staging.group.app';

    const switchToken = () => {
        AuthorizeService.getInstance()
            .getLoginToken()
            .then((response: any) => {
                if (response) {
                    window.location.assign(`${baseURL}/creategroup?utm_content=${utm_content}&${response.data}`);
                }
            }).catch((error: any) => {
                toast(`Error occured. Please try again later.`, {
                    type: 'error',
                    autoClose: 2000,
                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
                console.error(error)
                new Error(error)
            })
    }

    function showCommunitySwitcherFn() {
        return (
            window.location.pathname !== "/login" &&
            window.location.pathname !== "/signup" &&
            window.location.pathname !== "/verify-account" &&
            window.location.pathname !== "/create-community" &&
            window.location.pathname !== "/signin" &&
            window.location.pathname !== "/forgot-password" &&
            window.location.pathname !== "/reset-password" &&
            window.location.pathname.split("/")[1] !== "pages" &&
            window.location.pathname.split("/")[1] !== "pages-preview" &&
            !(
                window.location.pathname.split("/")[2] === "landing-pages" &&
                window.location.pathname.split("/").pop() === "edit"
            ) &&
            !(
                window.location.pathname.split("/")[2] === "certificates" &&
                window.location.pathname.split("/").pop() === "edit"
            ) &&
            !(
                window.location.pathname.split("/")[2] === "workflows" &&
                window.location.pathname.split("/").pop() === "edit"
            ) &&
            window.location.pathname !== "/upgrade" &&
            window.location.pathname !== "/onboarding" &&
            window.location.pathname !== "/creategroup" &&
            window.location.pathname !== "/plan-subscription" &&
            window.location.pathname !== "/plan-subscription/checkout" &&
            !window.location.pathname.includes("/purchase")

        );
    }

    if (topBarEl === null || window.location.pathname.split("/")[1] === "settings") {
        return <></>
    }

    if (!userId || window.location.pathname.split("/")[1] === "settings" || (selectedGroup && selectedGroup.hide_sidebar)) {
        return <></>
    }

    if (error) {
        return <></>
    }

    if (showCommunitySwitcherFn() && userId && selectedGroup && selectedGroup.id && isGroupDataRequired && showCommunitySwitcher) {
        if (!userGroups || !selectedGroup) {
            return (
                <aside
                    className={`${styles.CommunitieSwitcher}`} id='communities-sidebar'
                    style={isCustomgroupTheme ? { backgroundColor: theme, borderColor: theme } : {}}
                >
                    <div style={{ marginTop: '16px', width: '100%' }}>
                        {
                            Array(6).fill('').map((_e, i) => (
                                <ContentLoader
                                    speed={2}
                                    width={16}
                                    height={13}
                                >
                                    <rect x="3" y="0" rx="2" ry="2" width="8" height="8" />
                                </ContentLoader>
                            ))
                        }
                    </div>
                </aside>
            )
        }
        if (userGroups && userGroups.data && userGroups.data.length > 0) {
            return (
                <aside
                    className={`${styles.CommunitieSwitcher}`} id='communities-sidebar'
                    style={isCustomgroupTheme ? { backgroundColor: theme, borderColor: theme } : {}}
                >
                    <PerfectScrollbar
                        options={{
                            wheelPropagation: false,
                            suppressScrollX: true, // Add this to only show vertical scrollbar
                        }}
                        className={`${styles.CommunitieSwitcher__scrollarea}`}
                    >
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <Droppable droppableId="groups">
                                {(provided: any) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        {userGroups.data.map((group: any, index: number) => {
                                            const groupUrl = goToGroup(group);

                                            return (

                                                <Draggable key={group.id} draggableId={String(group.id)} index={index}>
                                                    {(provided: any) =>
                                                        groupUrl ? (
                                                            <a
                                                                className={styles.CommunitieSwitcher__group}
                                                                href={groupUrl}
                                                                onClick={(e) => {
                                                                    e.preventDefault(); // Prevent default link behavior
                                                                    window.location.href = groupUrl; // Force same-tab navigation
                                                                }}
                                                            >
                                                                <div
                                                                    title={group.name}
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                >

                                                                    <CommunityDetails group={group} selectedGroup={selectedGroup} />
                                                                </div>
                                                            </a>
                                                        ) : (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                className={styles.CommunitieSwitcher__group}
                                                                title={group.name}
                                                                onClick={(e) => e.stopPropagation()} // or leave it out if no interaction needed
                                                            >
                                                                <CommunityDetails group={group} selectedGroup={selectedGroup} />
                                                            </div>
                                                        )
                                                    }
                                                </Draggable>
                                            )
                                        })}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>


                        {
                            userGroups && userGroups.next_page_url &&
                            <div
                                onClick={() => loadMoreUserGroups()}
                                className={styles.CommunitieSwitcher__loadmore}>
                                <ThreeDotsIcon fill={isCustomgroupTheme ? '#fff' : '#666'} />
                            </div>
                        }

                        <div
                            className={styles.CommunitieSwitcher__add}
                            onClick={() => {
                                if (isVerified) {
                                    if (isCustomDomain) {
                                        switchToken()
                                        return;
                                    }
                                    window.location.assign(`${baseURL}/creategroup?utm_content=${utm_content}`);
                                    return;
                                } else {
                                    window.location.assign(`${baseURL}/verify-account?r=true`);
                                    return;
                                }
                            }}
                        >
                            <PlusIcon fill={isCustomgroupTheme ? '#fff' : '#666'} />
                        </div>
                    </PerfectScrollbar>
                </aside>
            )
        } else {
            return <></>
        }
    } else {
        return <></>
    }

}

const CommunityDetails = ({ group, selectedGroup }: { group: any, selectedGroup: any }) => {
    const [invalidImage, setInvalidImage] = React.useState(false);

    const onImageError = () => {
        setInvalidImage(true);
    }

    return (
        <div
            style={{ borderColor: group.id === selectedGroup.id ? '#365de6' : 'transparent' }}
            className={styles.CommunitieSwitcher__group__image}>
            {group.unread_notifications > 0 &&
                <div className={styles.CommunitieSwitcher__group__image__unread}>
                    {
                        group.id === selectedGroup.id
                            ?
                            selectedGroup.unread_notifications <= 9
                                ?
                                selectedGroup.unread_notifications
                                :
                                '9+'
                            :
                            group.unread_notifications <= 9
                                ?
                                group.unread_notifications
                                :
                                '9+'
                    }
                </div>
            }
            {(group.profile_image && !invalidImage) ?
                <img
                    src={group.profile_image}
                    alt="commmunity-profile-image"
                    onError={onImageError}
                />
                :
                <div
                    className={styles.CommunitieSwitcher__group__image__initials}
                    data-color={miscUtils.getColorInitial(`${group.name}`)}
                >
                    {miscUtils.getNameInitials(group.name)}
                </div>
            }
        </div>
    )
}

export default CommunitieSwitcher